<template>
  <div id="app">
    <notifications group="global" style="z-index:999999" position="bottom left"/>
    <div id="title-bar" v-if="authenticated" style="z-index:1000">
      <div id="brand"><span><img class="brand-image" src="/static/img/logo.png" alt="Shipping Board"></span></div>
      <user-area></user-area>
    </div>
    <div id="app-content">
      <load-screen v-show="pageLoading"></load-screen>
      <transition name="fade" mode="out-in">
        <router-view
          @loaded="pageLoading=false"
          @loading="pageLoading=true"
          :authenticated="authenticated"/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LoadScreen from '@/components/LoadScreen'
import UserArea from '@/components/UserArea'
export default {
  name: 'app',
  components: {LoadScreen, UserArea},
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated,
      notification: state => state.notification
    })
  },
  data () {
    return {
      pageLoading: false,
      pageIndex: 0
    }
  },
  watch: {
    notification (message) { if (!message) { return }; this.$notify(message) }
  },
  mounted () {
    if (!localStorage.getItem('vueml-lang')) {
      localStorage.setItem('vueml-lang', 'es')
    } else {
      if (localStorage.getItem('vueml-lang') !== 'es' && localStorage.getItem('vueml-lang') !== 'en') {
        localStorage.setItem('vueml-lang', 'es')
      }
    }
    this.$ml.change(localStorage.getItem('vueml-lang'))
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import './assets/scss/app.scss';
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0
}
#app-content {
    padding-top: 70px;
}
img{
  max-width: 100%;
  height: auto;
  padding: 8px 10px 0 0;
  box-sizing: border-box;
}
.brand-image {
  height: auto;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue